import React, { useState, useEffect } from 'react';
import { NotificationManager } from 'react-notifications';
import { Button } from 'reactstrap';
import AdminTable from './AdminTable';
import AdminModal from './AdminModal';
import shortid from 'shortid';
import { Page } from 'components/common';

const AdminDynamicTable = ({
  client,
  url,
  title,
  excludeHeaderFields = [],
  excludeEditFields = [],
  readOnly = []
}) => {
  const [records, setRecords] = useState([]);
  const [headerFields, setHeaderFields] = useState([]);
  const [editFields, setEditFields] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [action, setAction] = useState(null);
  const [currentItem, setCurrentItem] = useState(null);

  useEffect(() => {
    fetchData();
  }, [url]);

  const fetchData = async () => {
    try {
      const data = await client.get(url).get('data');
      setRecords(data.map(d => ({ key: shortid(), ...d })));
      if (data.length > 0) {
        const allFields = Object.keys(data[0]);
        setHeaderFields(determineFields(allFields, excludeHeaderFields));
        setEditFields(determineFields(allFields, excludeEditFields));
      }

    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const determineFields = (allFields, exclusions) => {
    return allFields
      .filter(key => !exclusions.includes(key))
      .map(key => key);
  };

  const formatField = (field) => {
    return field.split('_')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  };

  const openModal = (action, item) => {
    setAction(action);
    setCurrentItem(item);
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
    setAction(null);
  };

  const handleModalSave = async () => {
    try {
      if (currentItem){
        let { id, reference_id, ...itemData } = currentItem;

        if (reference_id === '') {
          reference_id = null;
        }
        if (reference_id !== undefined) {
          itemData.reference_id = reference_id;
        }

        if (action === 'edit' && currentItem.id) {
          await client.put(`${url}/${currentItem.id}`, itemData);
          NotificationManager.success(`${title} updated successfully`);
        } else if (action === 'add') {
          await client.post(url, itemData);
          NotificationManager.success(`${title} added successfully`);
        } else if (action === 'delete' && currentItem.id) {
          await client.delete(`${url}/${currentItem.id}`);
          NotificationManager.success(`${title} deleted successfully`);
        }
        fetchData();
        closeModal();        
      }
    } catch (err) {
      const error = err
      let errorMessage = [error.message];
      if (error.response && error.response.data){
        if (error.response.data.message) {
          errorMessage = JSON.stringify(err.response.data.message);          
        } 
        else {
          errorMessage = JSON.stringify(err.response.data[0]);
        }
        errorMessage = errorMessage.substring(1, errorMessage.length - 1).split("\\n")
      }
      errorMessage.forEach(line => {
        NotificationManager.error(line);
      })      
    }
  };


  return (
    <Page title={title}>
      <div className='d-flex'>
        <Button className='btn-info mr-2' onClick={() => openModal('add')}>
          Add New {title}
        </Button>
      </div>
      <AdminTable
        records={records}
        headerFields={headerFields}
        formatField={formatField}
        openModal={openModal}
        readOnly={readOnly}
      />
      <AdminModal
        modalOpen={modalOpen}
        closeModal={closeModal}
        action={action}
        title={title}
        currentItem={currentItem}
        editFields={editFields}
        handleModalSave={handleModalSave}
        formatField={formatField}
        setCurrentItem={setCurrentItem}
      />
    </Page>
  );
}

export default AdminDynamicTable;


// WEBPACK FOOTER //
// ./src/components/common/Tables/AdminDynamicTable.jsx